import { useMemo } from 'react';
import {
  Box,
  Divider,
  Typography,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DialogCTAComponent } from './PartnerEnrollmentCardCommon';
import { TestIds } from '../../../../assets/testIds';
import { useNavigationUtils } from '../../../../common/utils/useNavigationUtils';
import { getFormattedTestId } from '../../Content/ContentCommonFunctions';
import { usePartnerSpecificModalConfigMap } from './PartnerSpecificFormConfig';

interface EnrollmentConfirmationCardProps {
  partnerName?: string;
  partnerCode?: string;
  handleClose?: () => void;
  handleExternalAction?: () => void;
  loading?: boolean;
  isExistingAccountConfirmation: boolean
}

export function EnrollmentConfirmationCard({
  partnerName,
  partnerCode,
  handleClose,
  handleExternalAction,
  loading = false,
  isExistingAccountConfirmation,
}: EnrollmentConfirmationCardProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  const { openExternalLink } = useNavigationUtils();

  const partnerSpecificModalConfigMap = usePartnerSpecificModalConfigMap();
  const partnerConfig = useMemo(() => {
    if (!partnerCode || !(partnerCode in partnerSpecificModalConfigMap)) {
      return undefined; // or some default config
    }
    return partnerSpecificModalConfigMap[partnerCode];
  }, [partnerCode, partnerSpecificModalConfigMap]);

  return (
    <Box>
      <Divider sx={{ marginBottom: theme.spacing(3) }} />
      <Box sx={{
        marginBottom: theme.spacing(3),
        color: theme.palette.grey[500],
      }}>
        <Typography component='span'>
          {isExistingAccountConfirmation ? partnerConfig?.confirmationDescriptionExistingAcc :
            partnerConfig?.confirmationDescription}
        </Typography>
      </Box>
      <Divider sx={{ marginBottom: theme.spacing(3) }} />
      <Box>
        <DialogCTAComponent
          loading={loading}
          submitBtnTestId={`${TestIds.rewardsPage.signUpForm.partnerLinkBtn}-${getFormattedTestId(partnerName || '')}`}
          closeBtnTestId={`${TestIds.rewardsPage.signUpForm.closeBtn}-${getFormattedTestId(partnerName || '')}`}
          btnText={(isExistingAccountConfirmation ?
            partnerConfig?.confirmationBtnTextExistingAcc :
            partnerConfig?.confirmationBtnText) || ''}
          handleClick={() => {
            openExternalLink((
              isExistingAccountConfirmation ?
                partnerConfig?.confirmationBtnLinkExistingAcc :
                partnerConfig?.confirmationBtnLink
            ) || '');
            handleExternalAction?.();
          }}
        />
        <DialogCTAComponent
          loading={loading}
          submitBtnTestId={`${TestIds.rewardsPage.signUpForm.closeBtn}-${getFormattedTestId(partnerName || '')}`}
          closeBtnTestId={`${TestIds.rewardsPage.signUpForm.closeBtn}-${getFormattedTestId(partnerName || '')}`}
          btnText={`${t('button.done')}`}
          noBgColor={true}
          handleClick={handleClose}
        />
      </Box>
    </Box>
  );
}
